import * as React from 'react';
import { IoHomeOutline, IoCallOutline, IoMailOutline, IoClose } from "react-icons/io5";
import profile from '../../assets/profile.png';
import profile1 from '../../assets/profile1.png';
import './style.css';
export default function ViewMembers({ viewMemberModal, member }) {
  if (!member || !member.firstName) return null;

  const isActive = member.status === "ACTIVE";

  return (
    <div className="relative flex flex-col items-center px-6 pb-6 pt-6">
      {/* Close button */}
      <button
        onClick={() => viewMemberModal(null)}
        className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
      >
        <IoClose size={18} />
      </button>

      {/* Avatar with status ring */}
      <div className="relative mb-4 mt-2 h-20 w-20">
        {isActive && (
          <span className="absolute inset-0 blink rounded-full bg-green-400/40" />
        )}
        <img
          src={member.gender === "male" ? profile : profile1}
          alt={member.firstName}
          className={`relative h-20 w-20 rounded-full border-4 object-cover shadow-sm ${
            isActive ? "border-green-400" : member.status === "DROP" ? "border-gray-300" : "border-gray-200"
          }`}
        />
        <span
          className={`absolute bottom-1 right-1 h-4 w-4 rounded-full border-2 border-white ${
            isActive ? "bg-green-500" : member.status === "DROP" ? "bg-gray-300" : "bg-gray-400"
          }`}
        />
      </div>

      {/* Name + ID */}
      <h3 className="text-base font-bold text-[#262673]">
        {member.firstName.toUpperCase()} {member.lastName.toUpperCase()}
      </h3>
      <p className="mt-0.5 text-xs text-gray-400">({member.id})</p>

      {/* Designation badge, if present */}
      {member.designation && (
        <span className="mt-2 rounded-full bg-[#262673]/5 px-3 py-1 text-xs font-semibold text-[#262673]">
          {member.designation}
        </span>
      )}

      {/* Contact details */}
      <div className="mt-5 w-full space-y-3 rounded-xl border border-gray-100 bg-gray-50/50 p-4">
        {member.address && (
          <div className="flex items-start gap-2.5 text-sm text-gray-600">
            <IoHomeOutline size={16} className="mt-0.5 shrink-0 text-[#262673]" />
            <span>{member.address}</span>
          </div>
        )}
        <div className="flex items-center gap-2.5 text-sm text-gray-600">
          <IoCallOutline size={16} className="shrink-0 text-[#262673]" />
          <span>+91 {member.phoneNumber}</span>
        </div>
        <div className="flex items-center gap-2.5 text-sm text-gray-600">
          <IoMailOutline size={16} className="shrink-0 text-[#262673]" />
          <span className="truncate">{member.emailId}</span>
        </div>
      </div>

      {/* Close action */}
      <button
        onClick={() => viewMemberModal(null)}
        className="mt-6 w-full max-w-[200px] rounded-full border border-orange-200 py-2 text-sm font-semibold text-orange-500 transition-colors hover:bg-orange-50"
      >
        Close
      </button>
    </div>
  );
}